<template>
  <loader :task="task" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import { Customer } from '../types';
import repository from './customer-repository';

interface Data {
  task: Promise<Customer>|undefined,
}

export default defineComponent({
  emits: ['loaded', 'update:modelValue'],
  mixins: [HasTaskMixin],
  components: {
    Loader,
  },
  props: {
    customerId: {
      type: Number,
      required: true,
    },
    modelValue: Object as () => Customer,
  },
  data(): Data {
    return {
      task: undefined,
    };
  },
  watch: {
    customerId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.find(this.customerId);
      this.task.then((customer) => {
        this.$emit('update:modelValue', customer);
        this.$emit('loaded', customer);
      });
    },
  },
});
</script>
